module.exports = __webpack_public_path__ + "img/order_session_icon.7d600d47.svg";